import ContentEditable from "react-contenteditable";
import style from "./BarChart.module.css";
import sanitizeHTML from "sanitize-html";
import { ref, update } from "firebase/database";
import { db } from "../../../configs/Firebase";
import { useEffect, useState } from "react";

const BarChart = (props) => {
  const [hasRendered, setHasRendered] = useState(false);
  const [cellVal, setCellVal] = useState();

  useEffect(() => {
    if (!props.editable || !hasRendered) {
      setCellVal(props.data.value);
    }
    setHasRendered(true);
  }, [props.data.value]);

  function selectAll(e) {
    var range, selection;
    if (document.body.createTextRange) {
      range = document.body.createTextRange();
      range.moveToElementText(e.currentTarget);
      range.select();
    } else if (window.getSelection) {
      selection = window.getSelection();
      range = document.createRange();
      range.selectNodeContents(e.currentTarget);
      selection.removeAllRanges();
      selection.addRange(range);
    }
  }

  function isNumber(o) {
    return o === "" || !isNaN(o - 0);
  }
  function numbersOnly(e) {
    if (
      !isNumber(String.fromCharCode(e.keyCode)) &&
      e.keyCode !== 8 &&
      e.keyCode !== 37 &&
      e.keyCode !== 39 &&
      e.keyCode !== 190
    ) {
      e.preventDefault();
    }
  }
  function onChangeHandler(e, columnId) {
    let val = parseFloat(e.target.value);
    if (val > 100) {
      val = 100;
    }
    if (val < 0 || val === "" || isNaN(val)) {
      val = 0;
    }

    update(ref(db), {
      [props.journeyRefURL +
      "/rows/" +
      props.row.id +
      "/columns/" +
      columnId +
      "/value"]: sanitizeHTML(val),
    });
    setCellVal(val);
  }

  return (
    <div
      className={`${style.cell} ${props.first && style.first} ${
        props.last && style.last
      }`}
    >
      <div className={style.cellInner}>
        <div
          className={style.bar}
          style={{ "--val": props.data.value + "%" }}
        ></div>
      </div>
      <div className={style.value}>
        {props.editable ? (
          <ContentEditable
            html={sanitizeHTML(cellVal)}
            type="number"
            onKeyDown={numbersOnly}
            onChange={(e) => onChangeHandler(e, props.cellIndex)}
            onFocus={(e) => selectAll(e)}
          />
        ) : (
          <div
            dangerouslySetInnerHTML={{
              __html: sanitizeHTML(cellVal),
            }}
          />
        )}{" "}
        %
      </div>
    </div>
  );
};

export default BarChart;
